import { useRef } from 'react'
import { Icon } from '../../../assets/icons'
import {
  Wrapper,
  Overlay,
  Container,
  CloseGallery,
  Button,
  Footer,
  TeamName,
  Subtitle,
  TeamArea,
  SliderContent,
  SliderItem,
  SliderControlsContainer
} from './styles'
import { IImageProps, useGallery } from '../../../contexts/gallery'
import { getAssetUrl } from '../../../utils/assets_helpers'
import Slider from 'react-slick'
import { t } from '../../../adapters/translate/translate'

type Props = {
  isShowing: boolean;
  images: IImageProps[]
}

const GalleryModal = ({ isShowing, images }: Props) => {
  const { handleToggleGallery } = useGallery()
  const slider:any = useRef()
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  }

  function handleCloseGallery () {
    handleToggleGallery()
  }

  return (
    <Wrapper isShowing={isShowing}>
      <Overlay onClick={handleCloseGallery}/>
      <Container>
        <CloseGallery onClick={handleCloseGallery}>
          <Icon name="close" />
        </CloseGallery>

        <SliderContent>
          <SliderControlsContainer>
            <Button onClick={() => slider?.current?.slickPrev()}><Icon name="previous" /></Button>
            <Button onClick={() => slider?.current?.slickNext()}><Icon name="next" /></Button>
          </SliderControlsContainer>
          <Slider ref={slider} {...settings}>
            {images.map((item, idx) => (
              <SliderItem key={idx}>
                <img style={{ height: item.mission ? 'calc(100% - 180px)' : 'calc(100% - 160px)' }} src={getAssetUrl('game', item.url)} />
                <Footer style={{ height: item.mission ? 90 : 70 }}>
                  <TeamArea>
                    <Icon name="team" />
                    <TeamName>{item.teamName}</TeamName>
                  </TeamArea>
                  {item.subtitle && <Subtitle>{t('Team')}: {item.subtitle}</Subtitle>}
                  {item.mission && <Subtitle>{t('Mission')}: {item.mission}</Subtitle>}
                </Footer>
              </SliderItem>
            ))}
          </Slider>
        </SliderContent>
      </Container>
    </Wrapper>
  )
}

export default GalleryModal
